import { render } from "./Customizations.vue?vue&type=template&id=72272dc9"
import script from "./Customizations.vue?vue&type=script&lang=js"
export * from "./Customizations.vue?vue&type=script&lang=js"

import "./Customizations.vue?vue&type=style&index=0&id=72272dc9&lang=css"
script.render = render

export default script